export default __webpack_public_path__ + "static/media/it-25.1d87c599.svg";